// NATIVE 
import React from 'react';


// INSTALLED 


// CUSTOM 
import { useSelector } from 'react-redux';
import { Grid, TextField, Typography } from '@mui/material';





/**
 * DetailLog component displays detailed information about a log entry.
 * 
 * @param {any} props - The properties passed to the component.
 * 
 * @returns {JSX.Element} A React component that renders the details of a log entry.
 * 
 * @remarks
 * This component uses the `useSelector` hook to access the log data from the Redux store.
 * It also uses the `useEffect` hook to update the local state `dataLog` whenever the `log` changes.
 * 
 * @example
 * ```tsx
 * <DetailLog />
 * ```
 * 
 * @component
 * 
 * @example
 * ```tsx
 * // Example usage:
 * <DetailLog />
 * ```
 */
export const DetailLog = (props:any) => {

    
    // USE SELECTOR 
    const  [dataLog, setDataLog] = React.useState<any>();
    const { log, logs_list }:any  = useSelector( (state:any) => state.logs );
    

    // USE EFFECT 
    React.useEffect(() => {
        setDataLog(log);
    }, [log]);

    
    // CONST FUNCTION 
    const formatedDate = (date: Date) => {
            
          const event = new Date(date);
         return event.toLocaleString('es-CO');
         
    }


  return (
    <div>
            {
                dataLog &&

                  <>
                    <Grid>
                        <Grid item xs={12} sx={{ padding: 2 }}>
                            <Typography variant="h6" gutterBottom>
                                <span style={{ fontWeight: 700 }}>Accion:</span> {dataLog.name}
                            </Typography>
                        </Grid>
                    </Grid>
                    <Grid >
                        <Grid item xs={12} sx={{ padding: 1 }}>
                            <TextField
                                fullWidth
                                multiline
                                rows={5}
                                name={dataLog.description}
                                label={'Descripcion'}
                                defaultValue={dataLog.description}
                                InputProps={{
                                readOnly: true,
                                }}
                            />
                        </Grid>
                    </Grid>
                    <Grid>
                        <Grid item xs={12} sx={{ padding: 1 }}>
                            <Typography variant="h6" gutterBottom>
                               <span style={{ fontWeight: 700 }}>Ip:</span> {dataLog.ip}
                            </Typography>
                        </Grid>
                    </Grid>
                    <Grid>
                        <Grid item xs={12} sx={{ padding: 1 }}>
                            <Typography variant="h6" gutterBottom>
                              <span style={{ fontWeight: 700 }}>Usuario:</span> { ( dataLog.usuario.name ) ? dataLog.usuario.name : 'N/A' }
                            </Typography>
                        </Grid>
                    </Grid>
                    <Grid>
                        <Grid item xs={12} sx={{ padding: 1 }}>
                            <Typography variant="h6" gutterBottom>
                              <span style={{ fontWeight: 700 }}>Fecha:</span> { formatedDate(dataLog.fecha) }
                            </Typography>
                        </Grid>
                    </Grid>
                  </>
            }
        
            
                
    </div>
  )
}
